import React from 'react';
import { CustomerDelivery } from '../deliveriesTypes';
import { DeliveryStatusBadge } from './DeliveryStatusBadge';
import styles from './DeliveriesTable.module.css';

interface DeliveriesTableProps {
  deliveries: CustomerDelivery[];
  onViewDetails?: (deliveryId: string) => void;
}

export const DeliveriesTable: React.FC<DeliveriesTableProps> = ({
  deliveries,
  onViewDetails,
}) => {
  if (deliveries.length === 0) {
    return (
      <div className={styles.card}>
        <h2 className={styles.title}>Deliveries</h2>
        <div className={styles.empty}>
          <p className={styles.emptyText}>No deliveries found</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Deliveries</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>DELIVERY ID</th>
              <th className={styles.th}>ORDER #</th>
              <th className={styles.th}>DRIVER NAME</th>
              <th className={styles.th}>ETA</th>
              <th className={styles.th}>STATUS</th>
              <th className={styles.th}>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {deliveries.map((delivery) => (
              <tr key={delivery.id} className={styles.row}>
                <td className={styles.td}>
                  <span className={styles.deliveryId}>{delivery.deliveryId}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.orderNumber}>{delivery.orderNumber}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.driverName}>{delivery.driverName}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.eta}>{delivery.eta}</span>
                </td>
                <td className={styles.td}>
                  <DeliveryStatusBadge status={delivery.status} />
                </td>
                <td className={styles.td}>
                  <button
                    className={`${styles.viewBtn} ${delivery.status === 'Completed' ? styles.viewBtnGreen : ''}`}
                    onClick={() => onViewDetails?.(delivery.id)}
                  >
                    View Details
                    <svg viewBox="0 0 24 24" fill="currentColor" className={styles.viewIcon}>
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
